module.exports = __webpack_public_path__ + "img/icons8-lexus.f59d7e30.svg";